import * as React from "react";

interface IPoiDetailsCategoryProps {
    category: string;
    link: string;
}

const PoiDetailsCategory = ({ category, link }: IPoiDetailsCategoryProps) => {
    const handleChildClick = (e) => {
        e.stopPropagation();
    }
    return (<li><a onClick={handleChildClick} href={link}>{category}</a></li>);
};

export default PoiDetailsCategory;

